/*
 * @Author: caiqin.xie
 * @since: 2023-08-14 19:23:26
 * @LastEditors: caiqin.xie
 * @lastTime: 2023-11-24 12:11:47
 * @message: 服务支持主页-banner组件
 */
import React, { useState } from "react";
import { Input } from "@arco-design/web-react";
import { IconSearch } from "@arco-design/web-react/icon";
import styles from "../../index.module.scss";
import { quickSearchList } from '@/common/const';
import { useDevice } from "@/hooks";
import LazyMedia from "@/components/LazyMedia"
import { IBanner } from "@/common/types";

interface IProps {
  bannerList: IBanner[];
  ctry: string;
  words: Record<string, string>;
}

const Banner = (props:IProps) => {
  const {ctry, words, bannerList} = props
  const device = useDevice()
  const newDevice = (device === '' ? 'pc' : device === 'paid' ? 'pad' : device)
  const banner = bannerList[0] // banner
  const [keyword, setKeyword] = useState<string>('') // 搜索关键字
  const defaultBanner = require('../../assets/support_banner.jpg') // 默认banner
  // 跳转搜索页
  const handleSearch = () => {
    window.open(`/${ctry}/support/search?keyword=${keyword}`, '_self')
  }
  // 跳转搜索页，带标签
  const handleLabelClick = (item: Record<string, string>) => {
    if (keyword) {
      window.open(`/${ctry}/support/search?keyword=${keyword}&labelName=${words?.[item.name]}`, '_self')
    } else {
      window.open(`/${ctry}/support/search?labelName=${words?.[item.name]}`, '_self')
    }
  }

  return (
    <div className={styles["banner-wrap"]}>
      {banner
        ? (banner[newDevice].extension === '.mp4'
          ? <LazyMedia LazyClassName="full-wh" type="video" loop autoPlay preload="auto" playsInline muted src={banner[newDevice]?.url}></LazyMedia>
          : <LazyMedia LazyClassName="full-wh" type="image" src={banner[newDevice]?.url} alt={banner[newDevice]?.alt} />)
        : <LazyMedia LazyClassName="full-wh" type="image" src={defaultBanner} alt={banner?.name} />
      }

      <div className={styles["banner-content"]}>
        {banner?.isShowTitle === 1 && (
          <h1 className={styles["banner-title"]}>{banner?.name}</h1>
        )}
        {/* <p>
          {words.support_home_banner_desc}
        </p> */} 
        {/* PICO is committed to becoming a leading world-class XR platform, achieving developers and creators, and working together. */}
        <div className={styles["banner-search"]}>
          <Input
            prefix={<IconSearch />}
            size="large"
            placeholder={words.support_home_banner_search_placeholder}
            value={keyword.trim()}
            onChange={(value: string) => setKeyword(value)}
            onPressEnter={handleSearch} />
          {/* Search Support */}
        </div>
        <div className={styles["banner-quick-search"]}>
          {quickSearchList.map(item => (
            <span key={item.id} className={styles["quick-search-item"]} onClick={() => handleLabelClick(item)}>
              {words[item.name]}
            </span>
          ))}
          {/* Activities */}
          {/* Software */}
          {/* Hardware */}
          {/* Streaming */}
          {/* Policy */}
        </div>
      </div>
    </div>
  )
}
export default Banner